import { render, staticRenderFns } from "./CapacitacionesPantalla.vue?vue&type=template&id=7a365ce6&"
import script from "./CapacitacionesPantalla.vue?vue&type=script&lang=ts&"
export * from "./CapacitacionesPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7a365ce6', component.options)
    } else {
      api.reload('7a365ce6', component.options)
    }
    module.hot.accept("./CapacitacionesPantalla.vue?vue&type=template&id=7a365ce6&", function () {
      api.rerender('7a365ce6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/Capacitaciones/CapacitacionesPantalla.vue"
export default component.exports